/** Resolve the Agents webapp API shared by REST and streamed chat. */
export function resolveFarmartAIBaseUrl(value: string | undefined): string {
	if (!value?.trim()) {
		throw new Error('VITE_FARMART_AI_API_BASE_URL is required');
	}
	const url = new URL(value.trim());
	if (
		!['https:', 'http:'].includes(url.protocol) ||
		url.username ||
		url.password ||
		url.search ||
		url.hash
	) {
		throw new Error(
			'Agents API URL must be an HTTP(S) URL without credentials, query or fragment',
		);
	}
	const path = url.pathname.replace(/\/+$/, '');
	if (path !== '/agents' && path !== '/agents/webapp') {
		throw new Error('Agents API URL must end in /agents or /agents/webapp');
	}
	url.pathname = '/agents/webapp';
	return url.toString().replace(/\/$/, '');
}

export function getFarmartAIBaseUrl(): string {
	return resolveFarmartAIBaseUrl(import.meta.env.VITE_FARMART_AI_API_BASE_URL);
}
